import {Injectable} from '@angular/core';
import {HttpAuthService} from '@shared/service/http-auth.service';
import {Observable} from 'rxjs/Observable';
import {NotificationsList, NotificationsListPolling} from '../models/notifications-list.model';
import {NotificationFilter} from '../models/notification-filter.model';
import {Headers, RequestOptions, Response} from '@angular/http';
import {Utilities} from '@shared/utilities/utilities.model';
import {UserV3Service} from '@shared/service/user-v-3.service';
import {SelectCommoditiesService} from '@shared/service/select-commodities.service';
import {AppConfigEnvironment} from '@shared/models/appconfig-environment.model';
import {AppConfigEnvironmentService} from '@shared/service/appconfig-environment.service';
import {catchError, map, tap} from 'rxjs/operators';
import {throwError} from 'rxjs';

@Injectable()
export class NotificationService {
	environment: AppConfigEnvironment;


	constructor(private httpAuthService: HttpAuthService,
				private userV3Service: UserV3Service,
				private selectCommoditiesService: SelectCommoditiesService,
				private appConfig: AppConfigEnvironmentService) {
		this.environment = appConfig.Environment;
	}

	getListOfNotification(filter: NotificationFilter): Observable<NotificationsList> {
		let url: string = this.environment.NOTIFICATION + '/notifications?user_id=' + this.userV3Service.getCurrentUser().id + '&page_size=40&page=1';//Rug - pezza messa solo per visualizzare l'elenco, inserire la paginazione come da UX

		if (filter) {
			url = url + filter.getFilterUrl().replace(/\+/g, '%2B');
		}

		const options: RequestOptions = new RequestOptions();


		return new Observable<NotificationsList>(
			observer => {
				this.httpAuthService.get(url, this.environment.ROOT_REDIRECT, options).subscribe(
					response => {
						if (response.status === 200) {
							try {
								observer.next(new NotificationsList(response.json()));
							} catch (error) {
								observer.error(error);
							}
						} else {
							observer.next(null);
						}
					},
					error => {
						observer.error(error);
					});
			});
	}


	updateNotification(body: any, created_to?: any, notification_id?: any): Observable<Response> {
		const user_id: string = this.userV3Service.getCurrentUser().id;
		let url: string = this.environment.NOTIFICATION + '/notifications';
		if (!Utilities.isVoid(created_to)) {
			url = url + '?user_id=' + user_id + '&created_to=' + encodeURIComponent(created_to);
		} else if (!Utilities.isVoid(notification_id)) {
			url = url + '/' + notification_id + '?user_id' + user_id;
		}

		const options: RequestOptions = new RequestOptions();
		options.headers = new Headers();
		options.headers.set('Content-Type', 'application/json');


		return this.httpAuthService.patch(url, body, this.environment.ROOT_REDIRECT, options);
	}

	getNewNotifications(filter?: NotificationFilter): Observable<NotificationsListPolling> {
		let url: string = this.environment.NOTIFICATION + '/notifications/new?user_id=' + this.userV3Service.getCurrentUser().id;
		if (filter) {
			url = url + filter.getFilterUrl().replace(/\+/g, '%2B');
		}

		const options: RequestOptions = new RequestOptions();

		return new Observable<NotificationsListPolling>(
			observer => {
				this.httpAuthService.get(url, this.environment.ROOT_REDIRECT, options).subscribe(
					response => {
						if (response.ok ) {
							try {
								observer.next(new NotificationsListPolling(response.json()));
							} catch (error) {
								observer.error(error);
							}
						} else {
							observer.next(null);
						}
					},
					error => {
						observer.error(error);
					}
				);
			}
		);
	}
}
